import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TerminosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-850">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-851">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-852"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-853">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-854">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-855">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-856" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-857">
              Términos y Condiciones de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-858">
                Uso
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-859">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-860">
          <div data-id="element-861">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-862">
              1. ACEPTACIÓN DE LOS TÉRMINOS
            </h2>
            <p data-id="element-863">
              Al acceder, navegar, registrarse o utilizar el sitio web,
              aplicación móvil o cualquier plataforma digital oficial de
              Fundación REDORG (en adelante nombrados como la "Plataforma" y
              "REDORG" respectivamente), el usuario declara haber leído,
              entendido y aceptado íntegramente los presentes Términos y
              Condiciones, así como la Política de Privacidad vigente.
            </p>
            <p className="mt-2" data-id="element-864">
              Si el usuario no está de acuerdo con estos Términos, deberá
              abstenerse de utilizar la Plataforma.
            </p>
          </div>

          <div data-id="element-865">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-866">
              2. IDENTIFICACIÓN DEL TITULAR
            </h2>
            <p data-id="element-867">
              La Plataforma es operada por REDORG, entidad sin fines de lucro
              constituida conforme a las leyes de la República del Ecuador.
            </p>
          </div>

          <div data-id="element-868">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-869">
              3. USUARIOS
            </h2>
            <p className="mb-3" data-id="element-870">Pueden utilizar la Plataforma:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-871">
              <li data-id="element-872">Personas naturales mayores de 18 años</li>
              <li data-id="element-873">
                Menores de edad bajo la responsabilidad expresa de su padre,
                madre o representante legal, especialmente en el caso de
                escuelas deportivas
              </li>
            </ul>
            <p className="mt-2" data-id="element-874">
              El usuario es responsable de la veracidad de la información
              proporcionada durante su registro.
            </p>
          </div>

          <div data-id="element-875">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-876">
              4. SERVICIOS OFRECIDOS
            </h2>
            <p className="mb-3" data-id="element-877">La Plataforma permite, entre otros:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-878">
              <li data-id="element-879">
                Administración de organizaciones, aliados, socios y adherentes.
              </li>
              <li data-id="element-880">Administración y venta de productos y servicios.</li>
              <li data-id="element-881">
                Inscripción para eventos, capacitaciones, actividades u otros.
              </li>
              <li data-id="element-882">
                Pago de mensualidades, matrículas y otros valores relacionados
                con productos y servicios.
              </li>
              <li data-id="element-883">Acceso a contenido informativo, promocional y multimedia.</li>
              <li data-id="element-884">Otros productos y servicios.</li>
            </ul>
            <p className="mt-2" data-id="element-885">
              REDORG se reserva el derecho de modificar, suspender o eliminar
              servicios sin previo aviso.
            </p>
          </div>

          <div data-id="element-886">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-887">
              5. REGISTRO Y CUENTAS
            </h2>
            <p className="mb-3" data-id="element-888">
              Para acceder a ciertos servicios, el usuario deberá crear una
              cuenta proporcionando información veraz y actualizada.
            </p>
            <p className="mb-3" data-id="element-889">El usuario es responsable de:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-890">
              <li data-id="element-891">Mantener la confidencialidad de su usuario y contraseña.</li>
              <li data-id="element-892">Todas las actividades realizadas desde su cuenta.</li>
            </ul>
            <p className="mt-2" data-id="element-893">
              REDORG no será responsable por el uso no autorizado de cuentas por
              negligencia del usuario.
            </p>
          </div>

          <div data-id="element-894">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-895">
              6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-896">
              <li data-id="element-897">
                Los productos y servicios están sujetos a disponibilidad de
                stock.
              </li>
              <li data-id="element-898">
                Los precios incluyen los impuestos aplicables conforme a la ley
                ecuatoriana.
              </li>
              <li data-id="element-899">
                Las imágenes son referenciales; pueden existir variaciones
                mínimas.
              </li>
              <li data-id="element-900">
                Cambios o devoluciones solo se aceptarán por defectos de
                fabricación o falta de prestación de servicio, conforme a la
                política vigente.
              </li>
            </ul>
            <p className="mt-2" data-id="element-901">
              REDORG no se responsabiliza por retrasos atribuibles a terceros
              (courier, fuerza mayor, etc.).
            </p>
          </div>

          <div data-id="element-902">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-903">
              7. PAGOS Y TRANSACCIONES
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-904">
              <li data-id="element-905">
                Todos los pagos se procesan a través de plataformas seguras de
                terceros.
              </li>
              <li data-id="element-906">REDORG no almacena información bancaria sensible.</li>
              <li data-id="element-907">
                El usuario autoriza el débito de los valores correspondientes a
                los productos y servicios adquiridos.
              </li>
            </ul>
            <p className="mt-2" data-id="element-908">
              Cualquier reclamo deberá realizarse dentro de los plazos
              establecidos por la ley.
            </p>
          </div>

          <div data-id="element-909">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-910">
              8. PROPIEDAD INTELECTUAL
            </h2>
            <p data-id="element-911">
              Todo el contenido de la Plataforma (logos, escudos, textos,
              imágenes, videos, diseños, marcas y software) es propiedad
              exclusiva de REDORG o de terceros autorizados.
            </p>
            <p className="mt-2" data-id="element-912">
              Queda prohibida su reproducción, distribución o uso comercial sin
              autorización expresa y por escrito.
            </p>
          </div>

          <div data-id="element-913">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-914">
              9. USO PROHIBIDO
            </h2>
            <p className="mb-3" data-id="element-915">El usuario se compromete a no:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-916">
              <li data-id="element-917">Utilizar la Plataforma con fines ilícitos.</li>
              <li data-id="element-918">Realizar fraudes o suplantación de identidad.</li>
              <li data-id="element-919">Introducir virus, malware o códigos dañinos.</li>
              <li data-id="element-920">Afectar el funcionamiento de la Plataforma.</li>
            </ul>
            <p className="mt-2" data-id="element-921">
              El incumplimiento podrá resultar en la suspensión o cancelación
              inmediata de la cuenta.
            </p>
          </div>

          <div data-id="element-922">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-923">
              10. RESPONSABILIDAD Y LIMITACIONES
            </h2>
            <p className="mb-3" data-id="element-924">REDORG no garantiza:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-925">
              <li data-id="element-926">Disponibilidad ininterrumpida de la Plataforma.</li>
              <li data-id="element-927">Ausencia total de errores técnicos.</li>
            </ul>
            <p className="mt-2" data-id="element-928">
              El uso de la Plataforma se realiza bajo responsabilidad exclusiva
              del usuario.
            </p>
          </div>

          <div data-id="element-929">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-930">
              11. PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <p data-id="element-931">
              El tratamiento de los datos personales se rige por la Política de
              Privacidad de REDORG y la normativa vigente en Ecuador.
            </p>
          </div>

          <div data-id="element-932">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-933">
              12. VIGENCIA Y MODIFICACIONES
            </h2>
            <p data-id="element-934">REDORG podrá modificar estos Términos en cualquier momento.</p>
            <p className="mt-2" data-id="element-935">
              La vigencia de estos Términos y Condiciones de Uso es desde el 20
              de marzo de 2026 y permanecerá vigente hasta que exista una nueva
              versión que la reemplace.
            </p>
          </div>

          <div data-id="element-936">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-937">
              13. LEGISLACIÓN Y JURISDICCIÓN
            </h2>
            <p data-id="element-938">
              Estos Términos se rigen por las leyes de la República del Ecuador.
            </p>
            <p className="mt-2" data-id="element-939">
              Cualquier controversia será sometida a los jueces competentes de
              la ciudad de Guayaquil.
            </p>
          </div>

          <div data-id="element-940">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-941">
              14. CONTACTO
            </h2>
            <p data-id="element-942">
              Para consultas o reclamos, el usuario puede comunicarse a través
              de los canales oficiales de REDORG disponibles en la Plataforma.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}